import React, { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import JsonFormUpdateCreate from './JsonFormUpdateCreate';


export default function JsonFormSchemaUpload ({ setForms }) {
  const [open, setOpen] = useState(false);

  return (
    <Box sx={{ mt: 4 }}>
      <Typography variant="subtitle1">Nowe Formularze (JSONForms):</Typography>
      <Button variant="contained" onClick={() => setOpen(true)}>Dodaj formularz</Button>
      <JsonFormUpdateCreate open={open} setOpen={setOpen} setForms={setForms}/>
    </Box>
  );
};
